import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// SPA PC 中后台项目性能监控上报
import { setPageIdObj } from "../utils/common";
import { createInstance } from "./core";
var defaultOpt = {
  enabledWebVitals: true,
  enabledLongTask: true,
  enabledLocationChange: true,
  enablePageLoad: true,
  topPageid: '',
  // todo: 父级 iframe 的 pageid, 在 iframe 环境内时内才会加到 backup 里
  beforeSend: function beforeSend(params) {
    // console.log('beforeSend', params)
  },
  getPageInfoLazy: false,
  enableInitTestLegoSend: false
};
//
var legoPerfPc = function legoPerfPc() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpt;
  try {
    // 全局 ctx
    if (typeof window !== 'undefined') {
      var _window, _window$performance, _window2;
      var _options = Object.assign(defaultOpt, _objectSpread({}, options));
      // console.log('legoPerfPC', !window?.performance?.now)
      if (!((_window = window) !== null && _window !== void 0 && (_window$performance = _window.performance) !== null && _window$performance !== void 0 && _window$performance.now) && !((_window2 = window) !== null && _window2 !== void 0 && _window2.PerformanceObserver)) return;
      if (_options.routeList) setPageIdObj(_options.routeList);
      var ctx = createInstance(_options);
      return ctx;
    }
  } catch (err) {
    console.error(err);
  }
};
export default legoPerfPc;